export default __webpack_public_path__ + "76e8eba3b9b00be99a72086dcfcf72ed.png";